var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DateFormater } from './DateFormater';
import { TimeSpanPeriods } from './TimeSpan';
import { DateTimeConvertor } from './DateTimeConvertor';
import { StringUtils } from '../StringUtils';
export var DateTimeRangeOption;
(function (DateTimeRangeOption) {
    DateTimeRangeOption["DAILY"] = "panel.rangeSelect.daily";
    DateTimeRangeOption["H24"] = "panel.rangeSelect.24h";
    DateTimeRangeOption["D7"] = "panel.rangeSelect.7d";
    DateTimeRangeOption["D30"] = "panel.rangeSelect.30d";
    DateTimeRangeOption["D90"] = "panel.rangeSelect.90d";
    DateTimeRangeOption["RANGE"] = "panel.rangeSelect.range";
})(DateTimeRangeOption || (DateTimeRangeOption = {}));
class _DateTimeUtils {
    constructor() {
        this._TimeNow = null;
        this._TimeNowTicks = null;
        this._ZeroTime = new Date(0);
        this.TIME_UTC_OFFSET = new Date().getTimezoneOffset() * 60000;
        this.dateFormater = new DateFormater();
        this.StartDateTimeJavascriptYear = 1970;
    }
    DateTimeUtcNow() {
        if (!DateTimeUtils._TimeNow) {
            DateTimeUtils._TimeNow = new Date();
        }
        return DateTimeUtils._TimeNow;
    }
    DateTimeNow() {
        if (!DateTimeUtils._TimeNow) {
            DateTimeUtils._TimeNow = new Date();
        }
        return DateTimeUtils._TimeNow;
    }
    DateTimeUtcNowTicks() {
        if (!DateTimeUtils._TimeNowTicks) {
            DateTimeUtils._TimeNow = new Date();
            DateTimeUtils._TimeNowTicks = +DateTimeUtils._TimeNow;
        }
        return DateTimeUtils._TimeNowTicks;
    }
    SetDateTimeNow() {
        DateTimeUtils._TimeNow = new Date();
        DateTimeUtils._TimeNowTicks = +DateTimeUtils._TimeNow;
    }
    DateTimeToUTC(dt) {
        return new Date(dt.getTime() + DateTimeUtils.TIME_UTC_OFFSET);
    }
    toLocalUnixMillis(utcUnixMillis) {
        return utcUnixMillis + -1 * DateTimeUtils.TIME_UTC_OFFSET;
    }
    formatDate(date, format) {
        return this.dateFormater.formatMoment(date, format);
    }
    convertTicksToHHMMSS(ticks) {
        const difTime = new Date(ticks);
        const utsShiftTime = difTime.getTimezoneOffset() * 60000;
        const resultTime = new Date(ticks + utsShiftTime);
        return DateTimeUtils.formatDate(resultTime, 'HH:mm:ss');
    }
    LeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }
    FormatToTime(date, hideSeconds) {
        return DateTimeUtils.formatDate(date, hideSeconds ? NewDateFormater.TimeHideSecondsFormat : NewDateFormater.TimeFormat);
    }
    FormatToDate(date) {
        return DateTimeUtils.formatDate(date, NewDateFormater.DateFormat);
    }
    FormatToDateAndTime(date) {
        return DateTimeUtils.formatDate(date, NewDateFormater.TimeAndDateFormat);
    }
    getDateFromYYYYMMDD(dateS) {
        const year = dateS.substr(0, 4);
        const month = dateS.substr(4, 2);
        const day = dateS.substr(6, 2);
        const res = new Date();
        res.setFullYear(year);
        res.setMonth(month - 1);
        res.setDate(day);
        return res;
    }
    IsCurrentTimeInInterval(startTimeTicks, endTimeTicks) {
        const currentTime = Date.now();
        return startTimeTicks <= currentTime && endTimeTicks >= currentTime;
    }
    getDateWithoutTime(date) {
        date.setHours(0, 0, 0, 0);
        return date;
    }
    getRangeByOption(rangeOption, dateFrom = null, dateTo = null) {
        let startTime, finishTime;
        const nowTime = new Date();
        const Y = nowTime.getFullYear();
        const M = nowTime.getMonth();
        const D = nowTime.getDate();
        const nowMS = nowTime.getTime();
        switch (rangeOption) {
            case DateTimeRangeOption.DAILY:
                startTime = new Date(Y, M, D, 0, 0, 0).getTime();
                finishTime = new Date(Y, M, D, 23, 59, 59).getTime();
                break;
            case DateTimeRangeOption.H24:
                startTime = nowMS - TimeSpanPeriods.TicksPerDay;
                finishTime = nowMS;
                break;
            case DateTimeRangeOption.D7:
                startTime = nowMS - TimeSpanPeriods.TicksPerDay * 7;
                finishTime = nowMS;
                break;
            case DateTimeRangeOption.D30:
                startTime = nowMS - TimeSpanPeriods.TicksPerDay * 30;
                finishTime = nowMS;
                break;
            case DateTimeRangeOption.D90:
                startTime = nowMS - TimeSpanPeriods.TicksPerDay * 90;
                finishTime = nowMS;
                break;
            case DateTimeRangeOption.RANGE: {
                const dateFromTmp = dateFrom !== null && dateFrom !== void 0 ? dateFrom : new Date();
                const dateToTmp = dateTo !== null && dateTo !== void 0 ? dateTo : new Date();
                dateFromTmp.setHours(0);
                dateFromTmp.setMinutes(0);
                dateFromTmp.setSeconds(0);
                dateFromTmp.setMilliseconds(0);
                dateToTmp.setHours(23);
                dateToTmp.setMinutes(59);
                dateToTmp.setSeconds(59);
                startTime = dateFromTmp.getTime();
                finishTime = dateToTmp.getTime();
                break;
            }
        }
        return { startTime, finishTime };
    }
    getFormattedDate(date, convertToTimeZone = false) {
        if (!date || date.getTime() === 0) {
            return StringUtils.THREE_DASHES;
        }
        const dateToFormat = convertToTimeZone ? DateTimeConvertor.ConvertUTCTimeToSelectedTimeZone(date) : date;
        return this.formatDate(dateToFormat, NewDateFormater.DateFormat);
    }
}
export const DateTimeUtils = new _DateTimeUtils();
class _NewDateFormater {
    constructor() {
        this.TimeFormat = 'HH:mm:ss';
        this.TimeHideSecondsFormat = 'HH:mm';
        this.DateFormat = 'DD.MM.YYYY';
        this.TimeAndDateFormat = 'DD.MM.YYYY HH:mm:ss';
    }
}
export const NewDateFormater = new _NewDateFormater();
export const delay = (ms) => __awaiter(void 0, void 0, void 0, function* () {
    yield new Promise((resolve) => setTimeout(resolve, ms));
});
